module.exports = __webpack_public_path__ + "img/horizontal_5_1_8017.74649988.png";